import { Screen } from '../models/screen';
import { sendEvent } from '../store/analytics';

interface IInteraction {
  screen: Screen;
  interactionName: string;
  payload: { [properties: string]: unknown };
}

const isValidName = (str: string): boolean => {
  return /^(?:[A-Z][^\s]*\s?)+$/g.test(str);
};

export function trackInteraction({
  screen,
  interactionName,
  payload,
}: IInteraction): void {
  if (isValidName(interactionName)) {
    sendEvent(interactionName, { screen, ...payload });
  } else {
    console.error(
      `Parameter 'interactionName' must use 'Title Casing'. Value received: '${interactionName}'`,
    );
  }
}
